module.exports = __webpack_public_path__ + "static/media/Intermediate.cc4d93c1.png";